import { fromIso } from '@this/shared/dist/tools/datetime.js';
import { z } from 'zod';
import { DATE_FILTER_OPERATION, type DateFilter } from './operation.js';

export const dateValueSchema = z
    .string()
    // .datetime({ offset: true })
    .nullable()
    .optional()
    .transform((value) => (value ? fromIso(value) : undefined));

export const dateFilterSchema = z.union([
    z.object({
        operation: z.enum([DATE_FILTER_OPERATION.inArray.id]),
        array: z.string().array(),
        includeBlanks: z.boolean().optional(),
    }),
    z.object({
        operation: z.enum([
            DATE_FILTER_OPERATION.equals.id,
            DATE_FILTER_OPERATION.before.id,
            DATE_FILTER_OPERATION.after.id,
        ]),
        value1: z.date().optional(),
    }),
    z.object({
        operation: z.enum([
            DATE_FILTER_OPERATION.tomorrow.id,
            DATE_FILTER_OPERATION.today.id,
            DATE_FILTER_OPERATION.yesterday.id,
            DATE_FILTER_OPERATION.nextWeek.id,
            DATE_FILTER_OPERATION.thisWeek.id,
            DATE_FILTER_OPERATION.lastWeek.id,
            DATE_FILTER_OPERATION.nextMonth.id,
            DATE_FILTER_OPERATION.thisMonth.id,
            DATE_FILTER_OPERATION.lastMonth.id,
            DATE_FILTER_OPERATION.nextQuarter.id,
            DATE_FILTER_OPERATION.thisQuarter.id,
            DATE_FILTER_OPERATION.lastQuarter.id,
            DATE_FILTER_OPERATION.nextYear.id,
            DATE_FILTER_OPERATION.thisYear.id,
            DATE_FILTER_OPERATION.lastYear.id,
            DATE_FILTER_OPERATION.yearToDate.id,
        ]),
    }),
    z.object({
        operation: z.enum([DATE_FILTER_OPERATION.between.id]),
        value1: z.date().optional(),
        value2: z.date().optional(),
    }),
]);

export type DateFilterSchema = z.infer<typeof dateFilterSchema>;
export type DateFilterSchemaWithoutInArray = Exclude<
    DateFilterSchema,
    {
        operation: DateFilter['inArray']['id'];
    }
>;
